import "./index.scss";

import React, { useEffect, useState } from "react";
import axios from "axios";
import InputMessage from "../../common/InputMessage";
import CustomButton from "../../common/CustomButton";
import ServerError from "../../common/ServerError";

const CountdownForm = ({ setIsSuccess, isShown, type }) => {
  const [isServerError, setIsServerError] = useState(false);
  const [form, setForm] = useState({
    email: {
      value: "",
      error: "",
      isStarted: false,
    },
  });

  const [checkboxes, setCheckboxes] = useState({
    subscribe: false,
    agree: false,
  });

  useEffect(() => {
    setIsServerError(false);

    setForm({
      email: {
        value: "",
        error: "",
        isStarted: false,
      },
    });

    setCheckboxes({
      subscribe: false,
      agree: false,
    });
  }, [isShown]);

  const onChange = (e) => {
    const name = e.target.name;
    const value = e.target.checked;

    setCheckboxes((prevForm) => {
      return { ...prevForm, [name]: value };
    });
  };

  const validateInput = (name, value, started) => {
    let error = "";
    let isStarted = form[name].isStarted || started;

    if (isStarted && !value.length) {
      error = "This field is required.";
    } else {
      if (value && value.length > 2) {
        isStarted = true;
      }
    }

    if (isStarted && value) {
      switch (name) {
        case "email":
          const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
          const isEmailValid = expression.test(String(value).toLowerCase());
          error = !isEmailValid ? "Invalid email address." : "";
          break;
        default:
          break;
      }

      setForm({ ...form, [name]: { value } });
    }

    if (!value) {
      setForm({ ...form, [name]: { value: "", error, isStarted } });
    } else {
      setForm({ ...form, [name]: { value, error, isStarted } });
    }
  };

  const onBlur = (e) => {
    if (e.target.value.length < 2) {
      validateInput(e.target.name, e.target.value, true);
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    try {
      const typeName =
        type === "gallery"
          ? "MA Gallery"
          : type === "match"
          ? "MA Match"
          : type === "proof"
          ? "MA Proof"
          : "";

      const url =
        "https://europe-west2-maisonartplatform.cloudfunctions.net/setMAWebNotifyMe";

      const result = await axios({
        method: "post",
        url: url,
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": "eed22b87-da77-4667-88d3-76e8ba0bb23d",
        },
        data: {
          data: {
            userEmail: form.email.value,
            app: typeName,
          },
        },
      });

      if (result) {
        setIsSuccess(true);
        setIsServerError(false);
      }
    } catch (err) {
      console.error(err);
      setIsSuccess(false);
      setIsServerError(true);
    }
  };

  return (
    <form className={`countdown-form`} onSubmit={onSubmit}>
      <p className={`countdown-form__title`}>
        Get notified when the app hits the App Store
      </p>
      <div
        className={`black-form__group ${
          form.email.error && "black-form__group--error"
        } ${
          form.email.value && !form.email.error && "black-form__group--active"
        }`}
      >
        <input
          type="email"
          id="email"
          name="email"
          value={form.email.value}
          onBlur={onBlur}
          onChange={(e) => validateInput("email", e.target.value)}
          className={`countdown-form__input`}
          placeholder="Email address"
        />
        <InputMessage
          isValue={form.email.value}
          error={form.email.error}
          placeholderText={"Email address"}
        />
      </div>
      <div className={`countdown-form__checks`}>
        <div className="countdown-form__check countdown-form__check--subscribe">
          <input
            id="subscribe"
            type="checkbox"
            name="subscribe"
            hidden
            checked={checkboxes.subscribe}
            onChange={onChange}
            className={`countdown-form__input`}
          />

          <label
            htmlFor="subscribe"
            className={`countdown-form__check-label ${
              checkboxes.subscribe && "countdown-form__check-label--active"
            }`}
          >
            I’d like to receive news about Maison Art and all of its products.
          </label>
        </div>
        <div className="countdown-form__check countdown-form__check--subscribe">
          <input
            id="agree"
            type="checkbox"
            name="agree"
            hidden
            checked={checkboxes.agree}
            onChange={onChange}
            className={`countdown-form__input`}
          />
          <label
            htmlFor="agree"
            className={`countdown-form__check-label ${
              checkboxes.agree && "countdown-form__check-label--active"
            }`}
          >
            I have read and agree to the Privacy Policy and Terms and
            Conditions.
          </label>
        </div>
      </div>
      <CustomButton
        classNames={`countdown-form__button`}
        text={"notify me"}
        isSubmit={true}
        isDisabled={
          form.email.error ||
          !form.email.isStarted ||
          form.email.value.length < 2 ||
          !checkboxes.agree
        }
      />
      <ServerError isShown={isServerError} />
    </form>
  );
};

export default CountdownForm;
